import React from 'react';
import { withTranslation } from 'react-i18next';
import { CardElement, injectStripe } from 'react-stripe-elements';
import Button from './button';

class CardForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      canContinue: false
    }
    this.handleCardElementChange = this.handleCardElementChange.bind(this);
  }

  handleSubmit = (ev) => {
    ev.preventDefault();
    this.props.handleIsLoading(true);
    if (this.props.stripe) {
      this.props.stripe
        .createToken()
        .then((payload) => this.props.onGetToken(payload));
    } else {
      this.props.handleIsLoading(false);
      console.log("Stripe.js hasn't loaded yet.");
    }
  }

  handleCardElementChange(e) {
    if(this.props.onUpdate){
      this.props.onUpdate();
    }
    if(this.props.handleCanContinue){
      this.props.handleCanContinue(e.complete);
    }
    this.setState({canContinue: e.complete, cardElement: e})
  }

  render() {
    const { t, isLoading, inlineForm, formRef } = this.props;
    const { canContinue } = this.state;
    return <form ref={formRef} onSubmit={this.handleSubmit} className={inlineForm?"w-100":""} autoComplete="off">
      <div className={"form-group " + (inlineForm?"mb-0":"")}>
        <label className="sr-only">
          {t("Add New Card")}
        </label>
        <div className="form-control">
          <CardElement
              onChange={this.handleCardElementChange}
              hidePostalCode={true}
              {...createOptions(this.props.fontSize)}
            />
        </div>
      </div>
      {!inlineForm?
        <div className="d-flex">
          <Button type="secondary mx-auto btn-lg" disabled={this.props.disabled||!canContinue} loading={isLoading}>{this.props.paymentButtonText?t(this.props.paymentButtonText):t('Charge Card')}</Button>
        </div>
      :null}
    </form>
  }
}
export default withTranslation()(injectStripe(CardForm));

const createOptions = (fontSize, padding) => {
  return {
    style: {
      base: {
        fontSize: '16px',
        color: '#424770',
        letterSpacing: '0.025em',
        fontFamily: '"Lato", monospace',
        '::placeholder': {
          color: '#aab7c4',
        },
        ...(padding ? {padding} : {}),
      },
      invalid: {
        color: '#9e2146',
      },
    },
  };
};
